import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Endpoints } from 'src/environments/endpoints';
import {
  IcatalogClassification,
  IDermazoneReq,
  IDownloadCatalogs,
  IListProductType,
  IListSearchProductType,
  ISelectCatalogsRes,
  ParamsSearch,
} from '../model/http/catalogs';
import { ConsumeService } from './consume.service';
import {
  IAutoCompleteRes,
  IProductsDermaRes,
} from '../model/http/myActivity.model';
import { SpinnerNames } from '../constants/spinners';
import { NotificationMissingProduct } from '../model/http/notificationMissingProduct';
import { MockResponseNotificationMissingProduct } from 'src/mocks/responseNotificationMissingProduc';
import { BaseResponseHttp } from '../model/http/commons.model';
import { ItemClasificationCatalogTodos } from 'src/mocks/ItemsclasificationCatalog';
@Injectable({
  providedIn: 'root',
})
export class ProductCatalogService {
  constructor(private consumeService: ConsumeService) { }

  getListProductByType(queryParams: string): Observable<IListProductType> {
    return this.consumeService.httpGet<IListProductType>(
      `${Endpoints.catalogsProduct.getListProductType}${queryParams}`
    );
  }
  getcatalogClassification(
    queryParams: string
  ): Observable<IcatalogClassification> {
    return this.consumeService.httpGet<IcatalogClassification>(
      `${Endpoints.catalogsProduct.getCatalogClassification}${queryParams}`
    );
  }
  getCatalogDermazon(
    dermazoneReq: IDermazoneReq
  ): Observable<IProductsDermaRes> {
    return this.consumeService.httpPost<IProductsDermaRes>(
      Endpoints.catalogsProduct.dermazoneProducts,
      dermazoneReq
    );
  }
  postSendNotificationMissingProduct(body: NotificationMissingProduct[])
  : Observable<BaseResponseHttp> {
    return this.consumeService.httpPost<BaseResponseHttp>(
      Endpoints.catalogsProduct.postSendNotificationMissingProduct,
      body
    );
  }
  getSearchProductCatalog(
    params: ParamsSearch,
    spinnerName: SpinnerNames
  ): Observable<IListSearchProductType> {
    return this.consumeService.httpPost<IListSearchProductType>(
      Endpoints.catalogsProduct.getListProductType,
      params,
      null,
      false,
      spinnerName
    );
  }
  getDownloadCatalogs(
    params: string,
    spinnerName: SpinnerNames
  ): Observable<IDownloadCatalogs> {
    return this.consumeService.httpGet<IDownloadCatalogs>(
      `${Endpoints.catalogsProduct.getDownloadCatalogs}${params}`,
      null,
      null,
      spinnerName
    );
  }
  getSelectCatalogs(
    params: string,
    spinnerName: SpinnerNames
  ): Observable<ISelectCatalogsRes> {
    return this.consumeService.httpGet<ISelectCatalogsRes>(
      `${Endpoints.catalogsProduct.getSelectCatalogs}?${params}`,
      null,
      null,
      spinnerName
    );
  }
}
